import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SetKategori,
  paketActions,
  produkActions,
} from "../redux/actions/prepareActions";
import { showLog } from "../utils/log";

export default function Kategory(props) {
  const dispatch = useDispatch();
  const state = useSelector((state) => state?.dataPrepare);

  function onClickCategory(items) {
    showLog("Kategory Masuk onClickCategory");
    let newArr = [...state?.kategory];
    for (const x of newArr) {
      if (x.id == items.id) {
        x["selection"] = true;
      } else {
        x["selection"] = false;
      }
    }
    dispatch(SetKategori(newArr));
    dispatch({
      type: "SET_GET_DATA_PRODUK",
      value: {
        data: [],
        loading: true,
      },
    });
    if (items.label == "Paket") {
      dispatch(paketActions());
    } else {
      dispatch(
        produkActions({
          category_id: items.id,
        })
      );
    }
    if (items.label == "Promo") {
      props.setShowSubKategory(true);
    } else {
      props.setShowSubKategory(false);
    }
  }

  return (
    <div
      className="scrollbar"
      style={{
        margin: "20px 20px 0 20px",
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        overflow: "auto",
        whiteSpace: "nowrap",
        padding: 5,
      }}
    >
      {state?.kategory?.map((items, index) => (
        <div key={index}>
          {" "}
          <div
            onClick={() => items.Promo == onClickCategory(items)}
            style={{
              cursor: "pointer",
              backgroundColor: items["selection"] ? "#5451D6" : "#fff",
              marginRight: state?.kategory?.length == index ? 0 : 10,
              padding: "5px 20px",
              borderRadius: 20,
              display:
                items.label == "Promo Paket" || items.label == "Promo Diskon"
                  ? "none"
                  : false,
            }}
          >
            <div
              className="fonts500"
              style={{
                color: items["selection"] ? "#fff" : "#5451D6",
                fontSize: 12,
              }}
            >
              {(items.label || "")
                .split(" ")
                .map(
                  (word) =>
                    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                )
                .join(" ")}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
